import {
  Box,
  BoxProps,
  Flex,
  IconProps,
  Link,
  StackProps,
  Text,
} from '@chakra-ui/react';
import { LazyImage } from '~/components/LazyImage';

interface ContentFooter {
  icon: React.FC<IconProps>;
  label: string;
}

export interface Props extends BoxProps {
  aspectRatio: number;
  contentFooter: ContentFooter[];
  contentFooterBoxProps?: StackProps;
  contentId: string;
  contentSrc: string;
  link: string;
}

export const HighlightedContent: React.FC<Props> = ({
  aspectRatio,
  contentFooter = [],
  contentFooterBoxProps,
  contentId,
  contentSrc,
  link,
  ...props
}) => {
  return (
    <Box {...props}>
      <Link
        href={link}
        isExternal
        data-testid={`highlighted-content-${contentId}`}
      >
        <LazyImage
          src={contentSrc}
          ratio={aspectRatio}
          key={contentId}
          imageProps={{
            borderRadius: 'xl',
          }}
        />
      </Link>
      <Flex rowGap={2} marginTop={4} {...contentFooterBoxProps} wrap="wrap">
        {contentFooter.map((footer, index) => {
          return (
            <Box
              key={`footer-benchmark-${index}`}
              _notLast={{ marginRight: 6 }}
            >
              <footer.icon />
              <Text
                as="span"
                fontSize="md"
                fontWeight="medium"
                letterSpacing="wide"
              >
                {footer.label}
              </Text>
            </Box>
          );
        })}
      </Flex>
    </Box>
  );
};
